'use strict';

var $user = $('.isLoggedInUser');
var isUserRegistered = false;
isUserRegistered = $user.length !== 0 && $user.val() === 'true';

/**
 * Removes extra spaces and trims the input string.
 *
 * @param {string} value - The input string to normalize.
 * @returns {string} The normalized string with single spaces and no leading/trailing whitespace.
 */
function normalizeSpaces(value) {
    return value.replace(/\s+/g, ' ').trim();
}

/**
 * Marks the customer title dropdown section in the Bulk Order form as invalid.
 *
 * Adds the `is-invalid` CSS class to the `.custom-drop-down-section` element within
 * `.bulkorder-customer-title-wrapper` inside `#bulkOrderForm`, enabling invalid-state styling.
 *
 * @function addInvalidToCustomerTitle
 * @returns {void}
 */
function addInvalidToCustomerTitle() {
    $('#bulkOrderForm').find('.bulkorder-customer-title-wrapper .custom-drop-down-section').addClass('is-invalid');
}

/**
 * Removes the invalid state styling from the customer title custom dropdown in the bulk order form.
 *
 * Finds the customer title wrapper within `#bulkOrderForm` and removes the `is-invalid` CSS class
 * from `.custom-drop-down-section`, typically used to clear validation error highlighting.
 *
 * @function removeInvalidFromCustomerTitle
 * @returns {void}
 */
function removeInvalidFromCustomerTitle() {
    $('#bulkOrderForm').find('.bulkorder-customer-title-wrapper .custom-drop-down-section').removeClass('is-invalid');
}

/**
 * Marks the country code dropdown section in the bulk order form as invalid.
 *
 * Adds the `is-invalid` CSS class to `.custom-drop-down-section` within
 * `.bulk-order-phone-input-section` inside `#bulkOrderForm`.
 *
 * @function addInvalidToCountryCode
 * @returns {void}
 */
function addInvalidToCountryCode() {
    $('#bulkOrderForm').find('.bulk-order-phone-input-section .custom-drop-down-section').addClass('is-invalid');
}

/**
 * Removes the "is-invalid" validation state from the country code dropdown section
 * within the bulk order form's phone input area.
 *
 * @function removeInvalidFromCountryCode
 * @returns {void}
 */
function removeInvalidFromCountryCode() {
    $('#bulkOrderForm').find('.bulk-order-phone-input-section .custom-drop-down-section').removeClass('is-invalid');
}

/**
 * Validates an input field based on its name and updates error messages and styles.
 *
 * @param {jQuery} $input - The input element wrapped in jQuery.
 * @returns {boolean} True if the input is valid; otherwise, false.
 */
function validateInput($input) {
    var value = normalizeSpaces($input.val());
    const $form = $('#bulkOrderForm');
    $input.val(value);

    var pattern = $input.attr('pattern');
    var required = $input.prop('required');

    var $missingError = $input.siblings('.input-error-message');
    var $invalidError = $input.siblings('.invalid-error-message');

    if (required && !value) {
        $missingError.removeClass('d-none');
        $invalidError.addClass('d-none');
        $input.addClass('is-invalid');

        if ($input.hasClass('first-name-input')) {
            addInvalidToCustomerTitle();
        }

        if ($input.is('#BulkOrderPhone')) {
            addInvalidToCountryCode();
            $form.find('.missing-phone').removeClass('d-none').addClass('d-block');
        }

        $form.find('.invalid-firstName, .invalid-lastName, .invalid-phone, invalid-email').removeClass('d-block').addClass('d-none');
        $form.find('#BulkOrderPhone').removeClass('is-invalid-phone');
        return false;
    }

    if (pattern) {
        const regex = new RegExp(pattern);
        if (!regex.test(value)) {
            $missingError.addClass('d-none');
            $invalidError.removeClass('d-none');
            $input.addClass('is-invalid');

            if ($input.is('#BulkOrderPhone')) {
                addInvalidToCountryCode();
                $form.find('.missing-phone').removeClass('d-none').addClass('d-block');
            }

            return false;
        }
    }

    $missingError.addClass('d-none');
    $invalidError.addClass('d-none');
    $input.removeClass('is-invalid');
    return true;
}

/**
 * Resets (or sets) the "Customer Title" selection within the bulk order customer title UI.
 *
 * Finds the `.bulkorder-customer-title-wrapper` container, locates the custom dropdown options
 * (`.custom-option-value`), and updates:
 * - the selected `<li>` option (adds/removes the `selected` class),
 * - the visible label (`.selected-value`),
 * - and the hidden input `input[name="customerTitle"]` (stores the selected option code).
 *
 * Behavior:
 * - If `customerTitle` is provided and an option matches (by `data-title` or trimmed text),
 *   that option is selected.
 * - If `customerTitle` is not provided or no match is found, the first option is selected.
 * - If required DOM elements are missing, the function exits without changes.
 *
 * @param {string} [customerTitle] - The display title to select (matched against `data-title` or option text).
 * @returns {void}
 */
function resetCustomerTitle(customerTitle) {
    var bulkOrderCustomerTitle = customerTitle || '';
    var $nameSection = $('.bulkorder-customer-title-wrapper');
    if (!$nameSection.length) return;

    var $dropdown = $nameSection.find('.custom-drop-down-section');
    if (!$dropdown.length) return;

    var $options = $dropdown.find('.custom-option-value');
    if (!$options.length) return;

    var $display = $dropdown.find('.selected-value').first();
    var $hiddenInput = $nameSection.find('input[name="customerTitle"]');

    var $targetOption;

    // If customerTitle is passed → select matching option
    if (bulkOrderCustomerTitle) {
        $targetOption = $options.filter(function () {
            var title = $(this).attr('data-title') || $(this).text().trim();
            return title === bulkOrderCustomerTitle;
        }).first();
    }

    // If NOT passed or not found → select FIRST <li>
    if (!$targetOption || !$targetOption.length) {
        $targetOption = $options.first();
    }

    var nextTitle = $targetOption.attr('data-title') || $targetOption.text().trim();
    var nextCode = $targetOption.attr('data-code');

    // Reset selection
    $options.removeClass('selected');
    $targetOption.addClass('selected');

    // Update visible text
    if ($display.length) {
        $display.text(nextTitle);
    }

    // Update hidden field
    if ($hiddenInput.length && nextCode) {
        $hiddenInput.val(nextCode);
    }

    if (customerTitle) {
        $dropdown.addClass('non-editable');
    }
}

/**
 * Resets the country/phone dial code UI in the bulk order phone input section to a default value.
 *
 * If a `countryCode` is provided, the function attempts to select the matching option whose
 * `.custom-option-value` element has a `data-id` equal to `countryCode`. If no `countryCode`
 * is provided (or no match is found), it falls back to the first available option.
 *
 * Side effects:
 * - Updates the displayed selected value text (`.selected-value`, `.country-selected-value`) and marks it as active.
 * - Clears existing selection classes and applies selection to the resolved default option.
 * - Adds the `selected` class to the container to reflect selection state.
 * - Hides the dropdown option lists (`.custom-option-values`, `.country-dropdown-options`).
 *
 * @function resetCountryCodeToDefault
 * @param {string} [countryCode] - Dial/country code to select (matched against `data-id` on `.custom-option-value`).
 * @returns {void}
 */
function resetCountryCodeToDefault(countryCode) {
    var bulkOrderCountryCode = countryCode || '';
    var $container = $('.bulk-order-phone-input-section');
    var $defaultOption;

    // If countryCode is passed → use it
    if (bulkOrderCountryCode) {
        $defaultOption = $container
            .find('.custom-option-value[data-id="' + bulkOrderCountryCode + '"]')
            .first();
    } else { // Else → pick FIRST option from the list
        $defaultOption = $container.find('.custom-option-value').first();
    }

    if ($defaultOption.length) {
        var defaultCode = $defaultOption.data('id');

        // Update display
        $container.find('.selected-value, .country-selected-value')
            .text(defaultCode)
            .addClass('active');

        // Reset selected states
        $container.find('.custom-option-value, .country-option-item')
            .removeClass('selected');

        $defaultOption.addClass('selected');
        $container.addClass('selected');

        // Hide dropdown
        $container.find('.custom-option-values, .country-dropdown-options').hide();
    }

    if (countryCode) {
        $container.find('.custom-drop-down-section').addClass('non-editable');
    }
}

$(document).ready(function () {
    var $modal = $('#bulkOrderModal');
    var $form = $modal.find('.bulk-order-form');

    $('body').on('click', '#bulkOrderForm .custom-drop-down-section .title-code-option', function () {
        var code = $(this).attr('data-code');
        var title = $(this).attr('data-title');
        $('#bulkOrderForm .title-code').val(code);
        $('#bulkOrderForm .title-code').attr('data-customertitle', title);
    });

    // First & Last Name: allow single space between words, no digits
    // Email: allow valid email characters
    $form.find('input[name="firstName"], input[name="lastName"], input[name="email"]').on('input', function () {
        const $input = $(this);
        const inputName = $input.attr('name'); // 'firstName', 'lastName', or 'email'
        const originalValue = $input.val();
        let cleanedValue;

        if (inputName === 'email') {
            cleanedValue = originalValue.replace(/[^a-zA-Z0-9@._%+-]/g, ''); // allow valid email chars only
        } else {
            cleanedValue = originalValue.replace(/[0-9]/g, '') // remove digits
                .replace(/^\s+/, '') // remove leading spaces
                .replace(/\s{2,}/g, ' '); // collapse multiple spaces
        }
        $input.val(cleanedValue);

        const $missingError = $input.closest('.form-group').find('.input-error-message');
        const $invalidError = $input.closest('.form-group').find(`.invalid-${inputName}`);

        // Hide both errors initially
        $missingError.addClass('d-none').removeClass('d-block');
        $invalidError.addClass('d-none').removeClass('d-block');
        $input.removeClass('is-invalid');

        if ($input.hasClass('first-name-input')) {
            removeInvalidFromCustomerTitle();
        }

        // Empty or only spaces
        if (cleanedValue.trim() === '') {
            if (originalValue.trim() === '') {
                // User typed nothing or deleted everything → show "missing"
                $missingError.removeClass('d-none');
            } else {
                // User entered only spaces or digits → show "invalid"
                $invalidError.removeClass('d-none').addClass('d-block');
            }
            $input.addClass('is-invalid');

            if ($input.hasClass('first-name-input')) {
                addInvalidToCustomerTitle();
            }
        }
    });

    $form.find('input[name="phone"]').on('input', function () {
        const $input = $(this);
        $input.removeClass('is-invalid-phone');
        $input.removeClass('is-invalid');
        $form.find('.invalid-phone, .missing-phone').removeClass('d-block').addClass('d-none');
        removeInvalidFromCountryCode();
        let sanitizedValue = $input.val().replace(/[^0-9+]/g, '');
        var selectedCode = $('.bulk-order-phone-input-section .selected-value.active').text();

        // Prevent if starts with 0–5
        if (selectedCode === '+91' && /^[0-5]/.test(sanitizedValue)) {
            $input.val('');
            $form.find('.invalid-phone').removeClass('d-none').addClass('d-block');
            $form.find('.missing-phone').addClass('d-none').removeClass('d-block');
            addInvalidToCountryCode();
            $input.addClass('is-invalid-phone');
            return;
        }

        if ($input.val() === '') {
            $input.addClass('is-invalid-phone');
            $form.find('.missing-phone').removeClass('d-none').addClass('d-block');
            addInvalidToCountryCode();
        }
    });

    // --- Other input fields sanitization ---
    $form.find('.bulk-order-form-input').on('input', function () {
        const name = this.name;
        let value = this.value.replace(/[^\x20-\x7E]/g, '');
        if (name === 'email') {
            this.value = value.replace(/[^a-zA-Z0-9@._%+-]/g, '');
            // this.value = value.replace(/[^0-9]/g, '');
        } else if (name === 'company') {
            this.value = this.value.replace(/^\s+/, '').replace(/\s{2,}/g, ' ');
            $(this).removeClass('is-invalid').closest('.form-group').find('.input-error-message')
                .removeClass('d-block')
                .addClass('d-none');
        } else {
            this.value = value.replace(/[^a-zA-Z0-9\s.,'-]/g, '').replace(/\s{2,}/g, ' ');
        }
    });

    // --- Full validation only on blur ---
    $form.find('.bulk-order-form-input').on('blur', function () {
        validateInput($(this));
    });

    $form.find('input[name="email"]').on('blur', function () {
        // validateInput($(this));

        const $input = $(this);
        const value = $input.val().replace(/[^a-zA-Z0-9@._%+-]/g, ''); // allow valid chars only
        $input.val(value);

        const $invalidEmail = $input.closest('.form-group').find('.invalid-email');
        const $missingEmail = $input.closest('.form-group').find('.input-error-message');

        // Reset all messages
        $invalidEmail.addClass('d-none').removeClass('d-block');
        $missingEmail.addClass('d-none');
        $input.removeClass('is-invalid');

        // Empty → show missing message
        if (value.trim() === '') {
            $missingEmail.removeClass('d-none');
            $input.addClass('is-invalid');
            return;
        }

        // Must have at least one alphabet before '@'
        const beforeAt = value.split('@')[0];
        const hasAlphabetBeforeAt = /[a-zA-Z]/.test(beforeAt);

        if (!hasAlphabetBeforeAt) {
            $invalidEmail.removeClass('d-none').addClass('d-block');
            $input.addClass('is-invalid');
        }
    });

    // --- Updated phone input rule ---
    $('#BulkOrderPhone').on('input', function () {
        var $this = $(this);
        var selectedCode = $('.bulk-order-phone-input-section .selected-value.active').text();
        var val = $this.val().replace(/\D/g, '');
        var phoneLength = $('#BulkOrderPhone').attr('maxlength') || 10;

        // If +91 → don't allow starting digits 0–5
        if (selectedCode === '+91' && /^[0-5]/.test(val)) {
            val = val.replace(/^[0-5]+/, '');
        }

        // Limit to phoneLength digits
        val = val.substring(0, phoneLength);
        $this.val(val);
    });

    $('#bulkOrderForm  .bulk-order-phone-input-section .custom-option-value').on('click', function () {
        $('#BulkOrderPhone').val('');
        $('.phone-label').removeClass('d-none');
        $('.phone-input-section').find('.custom-drop-down-section, #BulkOrderPhone').removeClass('is-invalid');
        $('.missing-phone, .invalid-phone').removeClass('d-block').addClass('d-none');
        var phoneLength = $(this).data('phonelength');
        $('#BulkOrderPhone').attr('maxlength', phoneLength);
    });

    $modal.on('hidden.bs.modal', function () {
        if (!isUserRegistered) {
            $form.find('.bulk-order-form-input').each(function () {
                $(this).val('').removeClass('is-invalid');
                $(this).siblings('label').removeClass('d-none');
                $form.find('.invalid-firstName, .invalid-lastName,.invalid-phone, .invalid-email').removeClass('d-block').addClass('d-none');
                $form.find('#BulkOrderPhone').removeClass('is-invalid-phone');
            });
        } else {
            $form.find('.bulk-order-form-input').removeClass('is-invalid');
        }

        $form.find('.c-qty-input').each(function () {
            var minQty = parseInt($(this).data('qty-min') || 1, 10);
            $(this).val(minQty);
        });

        $modal.find('.input-error-message, .invalid-error-message').addClass('d-none').removeClass('d-block');
        $modal.find('.request-popup-section').removeClass('d-none');
        $modal.find('.confirm-popup-section, .confirm-bulk-order-section').addClass('d-none');
        $modal.find('.bulk-order-section').removeClass('d-none');
        $modal.find('#bulkOrderOtherDetails').val('');
        $('.action-btns-wrapper').removeClass('d-none');
        $('.bulk-order-desktop-section').addClass('d-none');

        resetCustomerTitle();
        resetCountryCodeToDefault();
        removeInvalidFromCountryCode();
    });

    $('.bulk-order-btn').on('click', function (e) {
        if (!($('.isLoggedInUser').length !== 0 && $('.isLoggedInUser').val() === 'true')) {
            $('#bulkOrderModal').modal('show');
            $form[0].reset();
            $form.find('.is-invalid').removeClass('is-invalid');
            $form.find('.placeholder').removeClass('d-none');
        } else {
            e.preventDefault();
            $('.action-btns-wrapper').addClass('d-none');
            $('.bulk-order-desktop-section').removeClass('d-none');
            $('.bulkorder-sticky-row').addClass('d-none');
        }

        var phoneLength = $('#bulkOrderForm').find('.bulk-order-phone-input-section .custom-option-value.custom-option-login.selected').data('phonelength');
        $('#BulkOrderPhone').attr('maxlength', phoneLength);
    });

    $('.bulk-order-desktop-btn').on('click', function () {
        var $customerTitle = $modal.find('.title-code').data('customertitle');
        var $firstName = $modal.find('#bulkOrderFirstName');
        var $lastName = $modal.find('#bulkOrderLastName');
        var $email = $modal.find('#bulkOrderEmail');
        var $mobileDialingCode = $modal.find('.bulkorder-mobile-dialing-code').val();
        var $phone = $modal.find('#BulkOrderPhone');

        if ($customerTitle) resetCustomerTitle($customerTitle);
        $firstName.val($firstName.attr('value')).prop('readonly', true);
        $lastName.val($lastName.attr('value')).prop('readonly', true);
        $email.val($email.attr('value')).prop('readonly', true);
        if ($mobileDialingCode) resetCountryCodeToDefault($mobileDialingCode);
        $phone.val($phone.attr('value')).prop('readonly', true);

        $('#bulkOrderCompany').val('');
        var phoneLength = $('#bulkOrderForm').find('.bulk-order-phone-input-section .custom-option-value.custom-option-login.selected').data('phonelength');
        $('#BulkOrderPhone').attr('maxlength', phoneLength);
        $('#bulkOrderModal').modal('show');
    });

    $('.bulk-order-form-input').on('input blur', function () {
        let $label = $(this).siblings('label');
        if ($(this).val().trim().length > 0) {
            $label.addClass('d-none');
        } else {
            $label.removeClass('d-none');
        }
    });

    $modal.on('shown.bs.modal', function () {
        if (isUserRegistered) {
            $form.find('.bulk-order-form-input').each(function () {
                let $label = $(this).siblings('label');
                if ($(this).val().trim().length > 0) {
                    $label.addClass('d-none');
                } else {
                    $label.removeClass('d-none');
                }
            });
        }
    });

    $('.bulk-order-submit-btn').on('click', function (e) {
        e.preventDefault();
        var isValid = true;

        $form.find('.bulk-order-form-input').each(function () {
            if (!validateInput($(this))) {
                isValid = false;
            }
        });

        if (!isValid) {
            return;
        }

        var $mobileField = $('#BulkOrderPhone');
        var mobileInput = $mobileField.val().trim();
        var phoneLength = parseInt($mobileField.attr('maxlength'), 10);

        if (phoneLength && mobileInput.length !== phoneLength) {
            $('.bulk-order-phone-input-section .phone-input-field').addClass('is-invalid');
            $mobileField.addClass('is-invalid');
            $('#bulkOrderForm .invalid-phone').removeClass('d-none');
            return;
        }
        var selectedCode = $('#bulkOrderForm #select-country-code').text() || '';
        var rawTitle = $('#bulkOrderForm .title-code').attr('data-customertitle') || $('#bulkOrderForm .selected-value').text() || '';
        var cleanTitle = String(rawTitle).replace(selectedCode, '').trim();
        var formdata = $form.serialize() + '&countryCode=' + encodeURIComponent(selectedCode) + '&title=' + encodeURIComponent(cleanTitle);

        $.spinner().start();
        $.ajax({
            url: $form.attr('action'),
            method: 'POST',
            data: formdata,
            dataType: 'json',
            success: function (response) {
                if (response.success) {
                    var data = response.data;
                    var productDetails = response.productDetails;
                    var customer = response.customer;

                    isUserRegistered = response.isRegistered && !!customer;

                    if (isUserRegistered) {
                        $modal.find('#bulkOrderFirstName').val(normalizeSpaces(customer.firstName));
                        $modal.find('#bulkOrderLastName').val(normalizeSpaces(customer.lastName));
                        $modal.find('#bulkOrderEmail').val(normalizeSpaces(customer.email));
                        $modal.find('#BulkOrderPhone').val(normalizeSpaces(customer.phone));
                        $modal.find('#bulkOrderCompany').val(normalizeSpaces(customer.company));
                    }

                    $modal.find('#bulkOrderOtherDetails').val('');

                    $modal.find('.request-popup-section').addClass('d-none');
                    $modal.find('.confirm-popup-section').removeClass('d-none');
                    $modal.find('.bulk-order-section').addClass('d-none');
                    $modal.find('.confirm-bulk-order-section .product-quantity').text(data.quantity);
                    $modal.find('.confirm-bulk-order-section').removeClass('d-none');

                    $modal.find('.product-name').text(productDetails.name);
                    $modal.find('.product-purity').text(productDetails.metalPurity);
                    $modal.find('.product-design-name').text($('.attribute-wrapper').find('.selected-design').text());
                    $modal.find('.product-weight').text(productDetails.netMetalWeight + ' ' + productDetails.netMetalWeightUnits);

                    var hasDesign = !!$('.attribute-wrapper').find('.selected-design').text().trim();
                    var hasWeight = !!(productDetails.netMetalWeight && productDetails.netMetalWeightUnits);
                    var hasPurity = !!productDetails.metalPurity;

                    $modal.find('.pipe-after-design').toggleClass('d-none', !(hasDesign && hasWeight));
                    $modal.find('.pipe-after-weight').toggleClass('d-none', !((hasDesign || hasWeight) && hasPurity));
                } else {
                    $('#bulkOrderModal').modal('hide');
                    $modal.find('#bulkOrderOtherDetails').val('');
                    var $allReadyHaveResponse = $('#allreadyhaveresponsebulkorder');
                    $allReadyHaveResponse.modal();
                    setTimeout(function () {
                        $allReadyHaveResponse.modal('hide');
                    }, 5000);
                    $('.bulkorder-sticky-row').removeClass('d-none');
                }
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
                $('#bulkOrderModal').modal('hide');
            }
        });
    });
});

$('.sign-in-btn').on('click', function () {
    $('#bulkOrderModal').modal('hide');
    $('#ckc-login-modal').modal('show');
});
